module.exports = ".margin{\r\n    margin-top: 10px;\r\n}\r\n\r\n/*\r\n.btn-primary {\r\n    color: #fff;\r\n    background-color: #007bff;\r\n    border-color: #007bff;\r\n    margin-bottom: 20px;\r\n    margin-top: -55px;\r\n}\r\n*/\r\n\r\n.btnallign{\r\n    margin-top: -73px;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/case-proceeding/cp-view/cp-view.component.css
// module id = ./src/app/legal/case-proceeding/cp-view/cp-view.component.css
// module chunks = main